module.exports = {
  init() {
    const self = this;
    // cache objects
    const { FRONT_CONFIG } = window;
    self.postalcodes = FRONT_CONFIG.postalCodeValidation?.regexByCountryCode;
    self.countryCode = FRONT_CONFIG.countryCode;
    self.countryRegexStr =
      FRONT_CONFIG.postalCodeValidation.regexByCountryCode[self.countryCode];

    $('.region-selector__select').each(function eachRegionSelectorSelect() {
      if (typeof self.countryRegexStr === 'object') {
        // If country regex is not a string, regex will depend on the selected region
        // thus we will listen for changes in that select
        self.listenChangeEvent(this);
      }
      // get selected option region code and use it to get the value in postalcode regex json
      self.updatePostalCodeRegex(this, self.getSelectedOptionRegion(this));
    });
  },
  listenChangeEvent(select) {
    const self = this;
    $('body').on('change', select, () => {
      const region = self.getSelectedOptionRegion(select);
      self.updatePostalCodeRegex(select, region);
    });
  },
  getSelectedOptionRegion(select) {
    const selectedOption = select.options[select.selectedIndex];
    return selectedOption ? selectedOption.value : null;
  },
  updatePostalCodeRegex(select, region) {
    const $parent = $(select).closest('form');
    const $postalcode = $parent.find('.zipCode');
    let regexString;
    // Use the regex defined for that region in the json
    // Or use the country regex
    // Or use a default regex
    if (typeof this.countryRegexStr === 'object' && region !== '') {
      regexString = this.countryRegexStr[region];
    } else if (typeof this.countryRegexStr !== 'object') {
      regexString = this.countryRegexStr;
    } else regexString = '^([0-9]{1,}){0,1}$';

    // Update pattern in postalcode field
    $postalcode.attr('pattern', regexString);
  },
};
